import { motion } from 'framer-motion'

export default function GlowButton({
  children,
  variant = 'primary',
  size = 'default',
  href,
  onClick,
  className = '',
  ...props
}) {
  const baseStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    fontWeight: 600,
    borderRadius: '9999px',
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    position: 'relative',
    overflow: 'hidden'
  }

  const sizeStyles = {
    small: { padding: '0.5rem 1.25rem', fontSize: '0.875rem' },
    default: { padding: '0.625rem 1.5rem', fontSize: '1rem' },
    large: { padding: '0.75rem 1.75rem', fontSize: '1rem' }
  }

  const variantStyles = {
    primary: {
      background: '#FFFFFF',
      color: '#0a0a1a'
    },
    secondary: {
      background: 'rgba(255, 255, 255, 0.08)',
      color: '#FFFFFF',
      border: '2px solid rgba(255, 255, 255, 0.4)'
    },
    solar: {
      background: 'linear-gradient(135deg, #FFD700 0%, #00FF88 100%)',
      color: '#0a0a1a'
    },
    outline: {
      background: 'rgba(10, 10, 26, 0.6)',
      backdropFilter: 'blur(8px)',
      color: '#FFFFFF',
      border: '2px solid rgba(255, 255, 255, 0.3)'
    }
  }

  const style = {
    ...baseStyles,
    ...sizeStyles[size],
    ...variantStyles[variant]
  }

  const Component = href ? motion.a : motion.button

  return (
    <Component
      href={href}
      onClick={onClick}
      className={className}
      style={style}
      whileHover={{
        y: -2,
        boxShadow: variant === 'solar'
          ? '0 0 40px rgba(255, 215, 0, 0.4)'
          : '0 10px 30px rgba(0, 0, 0, 0.2)'
      }}
      whileTap={{ scale: 0.98 }}
      transition={{ duration: 0.2 }}
      {...props}
    >
      {children}
    </Component>
  )
}
